import { render, staticRenderFns } from "./sortSubject.vue?vue&type=template&id=563db118&scoped=true"
import script from "./sortSubject.vue?vue&type=script&lang=js"
export * from "./sortSubject.vue?vue&type=script&lang=js"
import style0 from "./sortSubject.vue?vue&type=style&index=0&id=563db118&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563db118",
  null
  
)

export default component.exports